import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const adminApi = axios.create({
  baseURL: `${API}/admin`,
  withCredentials: true,
  timeout: 45000,
});

export const publicApi = axios.create({
  baseURL: API,
  timeout: 15000,
});

export function resolveImage(url) {
  if (!url) return `${API}/static/generated/placeholder.png`;
  if (url.startsWith("http")) return url;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
}
